import React,{useEffect, useState} from "react";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from "../../assets/ic_close_wh.svg";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import api from "../../utils/api";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { Button } from "../../common/Button/Button";
const ReactTableFixedColumns = withFixedColumns(ReactTable);


export default function AdminExpertAppointmentContainer() {

    const [data, setData] = useState()
    const [slotID, setSlotID] = useState('')
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [startDate, setStartDate] = useState(new Date());
    var CurrentDate = new Date().toLocaleDateString('en-CA')
    const [ExpertPartner, setExpertPartner] = useState()
    const [id, setId] = useState()
    const [ExpertName, setExpertName]= useState('')
    const [ResourceId, setResourceId] = useState('')
    const [cancelID, setCancelId]= useState('')


    let timeRN = moment(new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),'hh:mm A').format('HH:mm')
    console.log("CurrentTime==", timeRN)

    // let ResourceId 



    useEffect(() => {
        ExpertAppointmentData()
        // deleteSlot()
    },[])

    useEffect(() => {
        getDatabyID()
        ExpertCalenderData()
        if (ExpertPartner) {
            ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id) : ""))
            console.log("useEffectID", id)
        }
        setTimeout(() => {
            if (id) {
                // axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {
                //     headers: {
                //         Authorization: "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
                //     }
                // })
                api.getExpertById(id)
                    .then((res) => {
                        // alert(res.data)
                        setData(res.data)
                    })
            }
        }, 500);
    }, [id, ExpertName])

    let ExpertID = ""

    if (ExpertPartner) {
        console.log("POuter", ExpertPartner)
        ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? ExpertID = ele.refExternalServicePartner_id : ""))
    }

    const getDatabyID = () => {
        setId(ExpertID)
    }

    const ExpertCalenderData = () => {
        api.getAllExpertCalenderList().then(({ data }) => {
            console.log("Data", data)
            setExpertPartner(data)
        })
    }

    const dayNum = startDate.getDay()
    let day;
    if (dayNum === 0) {
        day = "Sunday"
    } else if (dayNum === 1) {
        day = "Monday"
    } else if (dayNum === 2) {
        day = "Tuesday"
    } else if (dayNum === 3) {
        day = "Wednesday"
    } else if (dayNum === 4) {
        day = "Thursday"
    } else if (dayNum === 5) {
        day = "Friday"
    } else {
        day = "Saturday"
    }

    const [commentsText, setCommentsText] = useState("")
    const [payloadDate, setPayloadDate] = useState("")

    const [expertTime, setExpertTime] = useState("")
    useEffect(() => {
        console.log('ExpertTime==', expertTime)
    },[expertTime])

    const [expertDay, setExpertDay] = useState("")
    console.log('ExpertDAy==', expertDay)


    let timeSlot = [];

    if (data) {
        console.log("GK==", data)
        data.filter((ele) => (ele.day === day) ? timeSlot.push(ele.time) : "");
    }


    const bookExpert = () => {
        if (expertTime === "") {
            toast("Expert Not Available for the Following Slot.", {
                type: toast.TYPE.ERROR,
            });
        } else {
            let payload;
            if (payloadDate) {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: payloadDate
                }
            } else {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: new Date().toLocaleDateString('en-CA')
                }
            }

            api.bookExpertAppointment(payload).then(res => {
                setExpertTime("")
                // setExpertDay('')
                // setCommentsText('')
                // setStartDate(new Date())


                if (res.data.message === "Expert Appointment Updated Successfully.") {
                    toast("Expert Appointment Updated Successfully and Previous Slot Cancelled.", {
                        type: toast.TYPE.SUCCESS,
                    });
                    setTimeout(() => {
                        setModalIsOpenToFalse()
                    }, 1000)
                    setExpertTime('')
                    setExpertDay('')
                    setCommentsText('')
                    setStartDate(new Date())
                    localStorage.removeItem("Resource")
                    deleteSlot(cancelID)
                } else {
                    toast("Appointment slot is unavailable .", {
                        type: toast.TYPE.ERROR,
                    });
                }
            })
        }
    }

    useEffect(() => {
        if(slotID){
            console.log("SlotID", slotID)
            let payload = {
                id: slotID
            }
            api.deleteExpertAppointment(payload)
            .then(({data}) => {
                console.log("Deleted",data)
                if(data === "Appointment Deleted Successfully."){
                    toast("Appointment Cancelled Successfully.", {
                        type: toast.TYPE.SUCCESS
                    })
                }
                setSlotID("")
                ExpertAppointmentData()
            })

        }
    }, [slotID])

    const ExpertAppointmentData = () => {
        api.getAllExpertAppointmentList().then(({data}) => {
            console.log("Appointments",data)
            setData(data)
        })
    }

    const deleteSlot = (element) => {
        let payload = {
            id: element
        }
            api.deleteExpertAppointment(payload)
            .then(({data}) => {
                console.log("Deleted",data)
                // if(data === "Appointment Deleted Successfully."){
                //     toast("Appointment Deleted Successfully.", {
                //         type: toast.TYPE.SUCCESS
                //     })
                // }
                setSlotID("")
                ExpertAppointmentData()
            })    
    }
    let bookTime
    const timeData = (ele) => {
        if(ele){
            let newTime = ele.split("-")
                let newTime1 = newTime[0]
                let ampm = newTime[1].split(" ")[1]

                let result = `${newTime1} ${ampm}`
                if(result === "11:00 PM"){
                    bookTime = "11:00"
                } else {
                    bookTime = moment(result, 'hh:mm A').format('HH:mm')
                }
                console.log("Booking==",bookTime)
        }
        
    }
    
    const columns = [
        {
            id:"nResourceInstanceId",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Resource Instance ID",
            accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 100,
        },
        {
            id:"expertName",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Expert Name",
            accessor: "expert_name",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 300,
        },
        // {
        //     id:"id",
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc' },
        //     Header: "ID",
        //     accessor: "id",
        //     style: { 'whiteSpace': 'unset' },
        //     width: 150,
        // },
        {
            id:"date",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Date Of Appointment",
            accessor: "bookdate",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 200,
        },
        {
            id:"day",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Slot Day",
            accessor: "slot_day",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 200,
        },
        {
            id:"time",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc', 'textAlign': 'center' },
            Header: "Slot Time",
            accessor: "slot_time",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 250,
        },
        {
            id:"comments",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Comments",
            accessor: "comments",
            style: { 'whiteSpace': 'unset','textAlign': 'center'  },
            width: 400,
        },
        {
            id:"delete",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc','borderRight': 'solid 1px #ccc','textAlign': 'center'  },
            Header: "Cancel Request",
            accessor: "status",
            style: { 'whiteSpace': 'unset','textAlign': 'center' },
            width: 250,
            Cell: ({row, original, index}) => {
                timeData(row._original.slot_time)
                return (
                    <>
                    {
                        row._original.bookdate < CurrentDate
                         || (row._original.bookdate === CurrentDate && bookTime < timeRN)
                        ? 
                        <span className="spled-black-text">Time Up</span> 
                        :
                        <div style={{
                            display: 'flex',
                            justifyContent: "space-around",
                            alignItems: "center"
                        }}>
                        <button
                        onClick={() => {
                            console.log(row._original)
                            setModalIsOpenToTrue()
                            setExpertName(row._original.expert_name)
                            setResourceId(row._original.nResourceInstanceId)
                            console.log("Expert==",ExpertName)
                            setCancelId(row._original.id)
                            // setSlotID(row._original.id)
                        }}
                        type="button" className={`my-services-model-cancel-btn
                        ${row._original.status === "Deleted" ? "disable" : ""}`}>Edit</button>
                        <button
                        style={{
                            width:"100px"
                        }}
                        className={`my-services-model-submit-btn
                        ${row._original.status === "Deleted" ? "disable" : ""}`} onClick={(e) => {
                            console.log("App date",row._original.bookdate, CurrentDate)
                        setSlotID(row._original.id)
                        getDatabyID()
                        //    deleteSlot()
                        }}>Cancel Request</button>
                        </div>
                    }
                    
                    </>               
                    // <button className={`my-services-model-submit-btn
                    // ${row._original.status === "Deleted" ? "disable" : ""}`} onClick={(e) => {
                    //     console.log("App date",row._original.bookdate, CurrentDate)
                    //    setSlotID(row._original.id)
                    // //    deleteSlot()
                    // }}>Cancel Request</button>
                )
            }
        },
        
    ]

    // const data= [
    //     {
    //         "id": 2,
    //         "slot_time": "01:00-02:00 PM",
    //         "slot_day": "Tuesday",
    //         "expert_name": "Mr. Ashok Magdum",
    //         "nResourceInstanceId": 2153
    //     },
    //     {
    //         "id": 19,
    //         "slot_time": "04:00-05:00 PM",
    //         "slot_day": "Friday",
    //         "expert_name": "Chittlesoft",
    //         "nResourceInstanceId": 2151
    //     },
    //     {
    //         "id": 21,
    //         "slot_time": "10:00-11:00 AM",
    //         "slot_day": "Monday",
    //         "expert_name": "Jugal Doshi",
    //         "nResourceInstanceId": 2155
    //     },
    //     {
    //         "id": 24,
    //         "slot_time": "02:00-03:00 PM",
    //         "slot_day": "Monday",
    //         "expert_name": "Gaurav Kulkarni",
    //         "nResourceInstanceId": 2155
    //     },
    //     {
    //         "id": 25,
    //         "slot_time": "02:00-03:00 PM",
    //         "slot_day": "Monday",
    //         "expert_name": "Shriram Kulkarni",
    //         "nResourceInstanceId": 2156
    //     },
    //     {
    //         "id": 32,
    //         "slot_time": "05:00-06:00 PM",
    //         "slot_day": "Thursday",
    //         "expert_name": "Jugal Doshi",
    //         "nResourceInstanceId": 205
    //     }
    // ]

    const setModalIsOpenToTrue = () => {
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    return (
        <>  

<Modal isOpen={modalIsOpen}>
                    <ModalContent className="general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Book an Expert Appointment</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={() => {
                                    setStartDate(new Date)
                                    setModalIsOpenToFalse()
                                    ExpertAppointmentData()
                                }
                                }
                            />
                        </div>
                        <div className="modal-body">
                            <div>
                                <span className="spled-colored-label" style={{ padding: '15px' }}>Expert Name :</span> <span className="spled-info-title">{ExpertName}</span>
                                {/* <div>
                                            <span className="spled-colored-label" style={{ padding: '15px' }}> Request ID: </span> <span className="spled-black-text">2</span>
                                        </div> */}
                                <div>
                                    <span className="spled-colored-label" style={{ padding: '15px' }}> Expert ID: </span> <span className="spled-black-text">{ExpertID}</span>
                                </div>
                                <div style={{
                                    display: 'flex'
                                }}>
                                    <div className="row container">
                                        <div className="col-6">
                                            <label className="my-services-model-value" style={{
                                                marginTop: '25px'
                                            }}>Book Appointment Date: </label>
                                            <DatePicker selected={startDate}
                                                dateFormat="dd/MM/yyyy" onChange={(date) => {
                                                    let payloadDate1 = date.toLocaleDateString('en-CA')
                                                    setPayloadDate(payloadDate1)
                                                    console.log("PayloadDate==", payloadDate)
                                                    setStartDate(date)
                                                    console.log("NewDate==", startDate)
                                                    setExpertDay("")
                                                    setExpertTime("")
                                                }} minDate={new Date()} width="300px" />

                                        </div>

                                        <div className="col-6" >
                                            <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                                            }}>Book Appointment Day: </label>
                                            {/* <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select> */}
                                            {/* <select style={{
                                                        width: "65%",
                                                        height: '35px',
                                                        padding: '5px'
                                                    }}
                                                        // onChange={({ target }) => {
                                                        //     setExpertTime(target.value)
                                                        // }}
                                                        // value={expertTime}
                                                        required
                                                    >
                                                        <option value={day} selected disabled hidden>{day}</option>
                                                    </select> */}
                                            <input type="text" value={day} style={{
                                                opacity: "0.4",
                                                pointerEvents: "none",
                                                width: "65%",
                                                height: '40px',
                                                padding: '5px'
                                            }} />
                                        </div>

                                        {/* <div className="col-6">
                                                    <label className="my-services-model-value" style={{
                                                        marginTop: '25px'
                                                    }}>Book Appointment Time: </label>
                                                    <br />
                                                     <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> 
                                                        <select style={{
                                                            width: "65%",
                                                        }} 
                                                        onChange={({target}) => {
                                                            setExpertTime(target.value)
                                                        }}
                                                        // value={expertTime}
                                                        >
                                                            <option value="none" selected disabled hidden>Select an Option</option>
                                                            {
                                                                timeSlot.map((ele,id) => {
                                                                    return <option key= {id}>{ele}</option>
                                                                })
                                                            }
                                                        </select>
                                                </div> */}
                                    </div>
                                </div>
                                <div className="row container">
                                    {/* <div className="col-12" style={{
                                                        marginLeft: '15px'
                                                    }}>
                                                        <label className="my-services-model-value" style={{
                                                            marginTop: '25px',
                                                            textAlign: 'center'
                                                        }}>Book Appointment Day: </label>
                                                        <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select>
                                                    </div> */}
                                    <div className="col-6">
                                        <label className="my-services-model-value" style={{
                                            marginTop: '25px'
                                        }}>Book Appointment Time: </label>
                                        <br />
                                        {/* <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> */}
                                        <select style={{
                                            width: "65%",
                                            height: '40px',
                                            padding: '5px'
                                        }}
                                            onChange={({ target }) => {
                                                setExpertTime(target.value)
                                            }}
                                            value={expertTime ? expertTime : "new"}
                                            required
                                        >
                                            <option value="new" selected disabled>Select an Option</option>
                                            {
                                                timeSlot.map((ele, id) => {
                                                    return <option key={id}>{ele}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-6" style={{
                                        // marginLeft : '10px'
                                    }}>
                                        <label className="my-services-model-value" style={{
                                            marginTop: '25px',
                                            textAlign: 'center',
                                        }}>Comments: </label>
                                        <textarea
                                            name="commentsAdded"
                                            className="w-100 h-50 form-control rounded"
                                            // value={serviceRequestEditableData.sFollowupNotes}
                                            onChange={(e) => {
                                                setCommentsText(e.target.value)
                                            }}
                                        // style={{ minHeight: "80px", maxHeight: "80px" }}
                                        />
                                    </div>
                                </div>





                                <div style={{
                                    margin: '10px',
                                    textAlign: 'center'
                                }}>
                                    <Button className="text-center" onClick={() => {

                                        bookExpert()
                                    }}>Book Appointment</Button>
                                </div>
                            </div>
                        </div>

                    </ModalContent>
                </Modal>

        <div className="row ml-5 mt-5">
        {/* <h4 className='conv-text-center conv-fontfamily-mont'>Expert Booked Appointments</h4> */}
            <ReactTableFixedColumns
                minRows={0}
                data={data}
                columns={columns}
                style={{ overflowY: "initial", height: "500px", maxWidth: '95%' }}
                className="-striped hide-scrollbar overflowcss"
            />
        </div>
        </>
    )
}
